import { useMediaQuery } from '@mantine/hooks';
import { useMemo } from 'react';

// Define screens object based on tailwind preset
const screens = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
  '3xl': '1920px',
};

interface UseScreenBreakpointOptions {
  getInitialValueInEffect: boolean;
}

export enum MediaQueryType {
  MAX = 'max-width',
  MIN = 'min-width',
}

export const useScreenBreakpoint = (
  breakpoint: keyof typeof screens,
  mediaQuery: MediaQueryType = MediaQueryType.MIN,
  initialValue?: boolean,
  options?: UseScreenBreakpointOptions,
) => {
  const query = `(${mediaQuery}:${screens[breakpoint]})`;

  /** pass this to useMediaQuery initialValue */
  const initValue = useMemo(() => {
    if (typeof initialValue === 'boolean') {
      return initialValue;
    }

    if ('matchMedia' in window) {
      return window.matchMedia(query).matches;
    }

    return undefined;
  }, [initialValue, query]);

  return useMediaQuery(query, initValue, options);
};
